import {Component, Input, OnInit} from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import {ITableData} from '@api/models/table/table';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';
import {LayoutService} from '@utils/services/layout/layout.service';
import {UrlService} from '@utils/services/url/url.service';

@Component({
  selector: 'lib-standings-table',
  templateUrl: './standings-table.component.html',
  styleUrls: ['./standings-table.component.scss'],
})
export class StandingsTableComponent implements OnInit {
  @Input() public useLinkToExpand = false;
  @Input() public expandLinkTarget = '_parent';
  @Input() public maxHeight = 'unset';
  @Input() public smallTable = false;
  @Input() public hideShadow = false;
  @Input() public kroneTable = false;
  @Input() public openLinksInNewTab = false;
  @Input() public showLeagueName = true;
  @Input() public showAllColumnNames = false;
  @Input() public expandable = false;
  @Input() public expandableVert = false;
  @Input() public spacedLayout = false;
  @Input() public condensed = false;
  @Input() public rowLimit: number;
  @Input() public initialRowLimit: number;
  @Input() public leagueName: string;
  @Input() public leagueLink: string;
  @Input() public leagueLogo: string;
  @Input() public tableData: ITableData;
  @Input() public color = '#888';
  @Input() public background = 'inherit';
  @Input() public highlightTeamId: string;
  @Input() public colorScheme: ColorScheme;
  @Input() public showMoreButton = false;
  public expanded = false;
  public buttonColorScheme = ColorScheme.Transparent;

  constructor(private layoutService: LayoutService) {
  }

  public ngOnInit(): void {
    if (this.layoutService.darkMode && !this.colorScheme) {
      this.colorScheme = ColorScheme.Dark;
    }
    if (this.kroneTable) {
      this.smallTable = true;
    }
    if (this.expandableVert) {
      this.rowLimit = this.rowLimit || 4;
      this.initialRowLimit = this.rowLimit;
    }
  }

  public getLinkOfTeam(readableId: string): string {
    if (readableId) {
      return UrlService.getSubdomainUrl(readableId);
    }
    return '#';
  }

  public onToggleTable(): void {
    this.smallTable = !this.smallTable;
    this.expanded = !this.expanded;
  }

  public onToggleExpandVert(): void {
    this.rowLimit =
      this.rowLimit === this.initialRowLimit ? null : this.initialRowLimit;
  }

  public get moreLink(): string {
    return (this.leagueLink || '') + '/tabelle';
  }
}
